import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { NotificationEmail } from '../_models/notificationEmail';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from './index';


@Injectable()
export class NotificationEmailService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }

  getAll(): Observable<NotificationEmail[]>{
    let notificationEmails$ = this.http
      .get(`${this.baseUrl}/notificationemails`, this.makeHeaders())
      .map(mapEmails)
      .catch(handleError);
    return notificationEmails$;
  }

  getNotificationEmails(dealerId: string, type: string): Observable<NotificationEmail[]>{
    let notificationEmails$ = this.http
      .get(`${this.baseUrl}/notificationemails?dealer_id=${dealerId}`, this.makeHeaders())
      .map(mapEmails)
      .catch(handleError);
    return notificationEmails$;
  }

  get(id: string): Observable<NotificationEmail> {
    let notificationEmail$ = this.http
      .get(`${this.baseUrl}/notificationemails/${id}`, this.makeHeaders())
      .map(mapEmail);
    return notificationEmail$;
  }

  create(notificationEmail: NotificationEmail): Observable<NotificationEmail> {
    let newNotificationEmail = this.http
      .post(`${this.baseUrl}/notificationemails`, JSON.stringify(notificationEmail), this.makeHeaders())
      .map(mapEmail);
    return newNotificationEmail;
  }

  delete(id: string): Observable<NotificationEmail> {
    return this.http
      .delete(`${this.baseUrl}/notificationemails/${id}`, this.makeHeaders())
      .map((res:Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error:any) => Observable.throw(error.json().error || 'Server error')); //...errors if any;
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function mapEmails(response: Response): NotificationEmail[]{
    // uncomment to simulate error:
    // throw new Error('ups! Force choke!');
    return response.json().map(toEmail);
 }
 
 function toEmail(r:any): NotificationEmail {
   let notificationEmail = <NotificationEmail>({
       _id: r._id,
       email: r.email,
       dealer_id: r.dealer_id,
       type: r.type
   });
   //console.log('Parsed notification email:', notificationEmail);
   return notificationEmail;
 }
 
 function mapEmail(response:Response): NotificationEmail{
   // toPerson looks just like in the previous example
   return toEmail(response.json());
 }
 
 // this could also be a private method of the component class
 function handleError (error: any) {
   // log error
   // could be something more sofisticated
   let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
   console.error(errorMsg);
 
   // throw an application level error
   return Observable.throw(errorMsg);
 }



// WEBPACK FOOTER //
// ./src/app/_services/notificationemails.service.ts